export default "__VITE_ASSET__D3fo1a_6__"